import { CollectionsHelper } from '@/helpers/collections.helper';
import apiClient from '@/services/api-client';
/**
 * @typedef {import('@/models/location.interface').Location} Location
 */
/**
 * @template S, R
 * @typedef {import('vuex').ActionTree<S, R>} ActionTree<S, R>
 */
/**
 * @template S
 * @typedef {import('vuex').MutationTree<S>} MutationTree<S>
 */
/**
 * @template S, R
 * @typedef {import('vuex').GetterTree<S, R>} GetterTree<S, R>
 */
/**
 * @template S, R
 * @typedef {import('vuex').Module<S, R>} Module<S, R>
 */
/**
 * @typedef {import('@/store/root.state').RootState} RootState
 */

/**
 * @typedef {Object} SharedLocationsState
 * @property {Location[]} locations
 */

/** @returns {SharedLocationsState} */
const getInitialState = () => ({
  locations: [],
});

const state = getInitialState();

/** @type {GetterTree<SharedLocationsState, RootState>} */
const getters = {
  locations: (state) => state.locations,
};

/** @type {ActionTree<SharedLocationsState, RootState>} */
const actions = {
  getLocations: async ({ commit }) => {
    const { data } = await apiClient.locationsApi.getLocations();

    commit('setLocations', data);
  },
};

/** @type {MutationTree<SharedLocationsState>} */
const mutations = {
  setLocations: (state, locations) => state.locations = CollectionsHelper.sortObjectsByProperty(locations, 'title'),
  resetModuleState: (state) => Object.assign(state, getInitialState()),
};

/** @type {Module<SharedLocationsState, RootState>} */
export const locations = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
